import styled from "styled-components";
import image from "../../assets/vuesax-linear-arrow-right.svg";

export const Page3Container = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  background-color: black;
  background-size:cover ;
  /* height:100vh; */
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -ms-flex-direction:column;
          flex-direction:column;

  @media screen and (min-height: 750px) {
    height: 100vh;
  }
  
`;

export const Page3Wrapper = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
          flex-direction: column;
  height: 80%;
  -webkit-box-align: center;
  -ms-flex-align: center;
          align-items: center;
  background-color: black ;



`;
export const Page3Head = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
          justify-content: center;
  background-color: transparent;
  height: 280px;


  @media screen and (max-height: 900px) {
    height: 196px;
  }

  @media screen and (max-width: 700px) {
    height: 160px;
  }

`;
export const Page3HeadWrapper = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
          justify-content: center;
  height: 600px;
  width: 600px;
  top: -320px;


  @media screen and (max-height: 900px) {
    height: 420px;
    width: 420px;
    top: -224px;
  }

  @media screen and (max-width: 700px) {
    height: 300px;
    width: 300px;
    top: -140px;
  }

  @media screen and (max-width: 500px) {
    margin: 0px 20px;
  }

`;
export const FirstEllipseContainer = styled.img`
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;

  @media screen and (max-height: 900px) {
    width: 420px;
    height: 420px;
  }

  @media screen and (max-width: 700px) {
    width: 300px;
    height: 300px;
  }
`;
export const SecondEllipseContainer = styled.img`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  margin: 100px;

  @media screen and (max-height: 900px) {
    width: 280px;
    height: 280px;
    margin: 70px;
  }

  @media screen and (max-width: 700px) {
    width: 200px;
    height: 200px;
    margin: 50px;
  }
`;
export const Logo = styled.img`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  width: 80px;
  height: 74px;
  margin: 366px 261px 141px 260px;

  @media screen and (max-height: 900px) {
    margin: 256.2px 182.7px 98.7px 182px;
  }

  @media screen and (max-width: 700px) {
    margin: 163px 130.5px 70.5px 130px;
  }
`;
export const Page3Content = styled.div`
  margin-top: 20px;
`;

export const Page3Captions = styled.div``;
export const PageFirstTextCaption = styled.h1`
  color: white;
  font-size: 60px;
  text-align: center;
  line-height: 69px;

  @media screen and (max-height: 900px) {
    font-size: 55px;
    line-height: 64px;
  }
  @media screen and (max-width: 700px) {
    font-size: 40px;
    line-height: 60px;
  }
`;
export const PageFirstTextSpan = styled.span`
  color: white;
  font-size: 60px;
  margin-left: 20px;
  color: #40a9ff;

  @media screen and (max-width: 700px) {
    font-size: 40px;
    line-height: 60px;
  }
`;
export const PageSecondTextCaption = styled.h3`
  color: white;
  text-align: center;
  font-size: 24px;
  font-weight: normal;
  text-align: center;
  line-height: 28px;


  @media screen and (max-width: 700px) {
    font-size: 20px;
    line-height: 24px;
    margin: 0px 10px;
    font-size: 16px;
  }
`;
export const Page3Card = styled.section`
  border-radius: 10px;
  background-color: #262626;
  width: 536px;
  margin-top: 30px;

  @media screen and (max-width: 700px) {
    width: 400px;
  }

  @media screen and (max-width: 500px) {
    width: 300px;
  }
`;
export const Page3CardCaption = styled.h3`
  font-size: 20px;
  color: white;
  margin-left: 32px;
  padding: 20px 0px;
  font-weight: normal;
`;
export const WalletContainer = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
          justify-content: center;

`;
export const WalletType = styled.a`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
          flex-direction: row;
  background-color: black;
  border-radius: 7px;
  color: white;
  margin-top: 8px;
  margin-left: 32px;
  margin-right: 32px;
  padding: 16px 8px;
  -webkit-box-align: center;
  -ms-flex-align: center;
          align-items: center;
  max-height: 60px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  background-image: url(${image});
  background-repeat: no-repeat;
  background-position: 95% 50%;
  background-size: 20px;

  @media screen and (max-width: 500px) {
    margin: 0px 20px;
    margin-top: 5px;
  }

  @media screen and (max-width: 400px) {
    margin: 0px 10px;
    margin-top: 5px;
  }
`;

export const WalletIcon = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
          justify-content: center;
  width: 47px;
  height: 47px;
  /* background-color: #666666; */
  border-radius: 5px;
  margin-right: 10px;
`;
export const Page3ButtonContainer = styled.div`
  margin: 20px 32px;
  display: grid;
  display: -ms-grid;
  grid-template-columns: auto auto;
  grid-column-gap: 10px;

  @media screen and (max-width: 500px) {
    margin: 20px 20px;
  }

  @media screen and (max-width: 400px) {
    margin: 20px 10px;
  }
`;

export const FirstPage3Button = styled.button`
  font-size: 16px;
  border: 1px white solid;
  color: white;
  background-color: transparent;
  height: 63px;
  border-radius: 10px;
`;
export const SecondPage3Button = styled.button`
  font-size: 16px;
  border: none;
  border-radius: 10px;
  background-color: #40a9ff;
  color: white;
`;
